(function() {
    'use strict';

    angular
        .module('appback')
        .controller('CarriersController', CarriersController)

    CarriersController.$inject = ["CuentaService", "CarrierService", "GenerallabService", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce"];

    function CarriersController(CuentaService, CarrierService, GenerallabService, $http, $timeout, $uibModal) {
        var vm = this;
        vm.modalInstance = "";
        vm.generalService = GenerallabService;
        vm.show = false;
        vm.historico = [];
        vm.getHistory = function(type, materialId, tracking) {
            CarrierService.getHistory(type, materialId, tracking).then(function(response) {
                vm.historico = response.data;
            }).catch(function(error) {
                console.error(error);
            });

        }
        vm.getTracking = function(id, carrierId, reference) {
            CarrierService.getTracking(carrierId, id, reference).then(function(response) {

                vm.getHistory(id);
                vm.show = true;
            }).catch(function(error) {
                console.error(error);
            });
        };

        vm.getEtiqueta = function(type, id, tracking) {
            CarrierService.getEtiqueta(type, id, tracking).then(function(response) {
            // 1. Definimos la URL de nuestra acción que ahora devuelve un JSON
            var urlEtiqueta = '/backend/carrier/etiqueta?type=' + type + '&material_id=' + id + (tracking ? '&tracking=' + tracking : '');

            // 2. Hacemos un fetch/get para obtener el array de imágenes Base64
            $.getJSON(urlEtiqueta, function(listaBase64) {
                
                printJS({
                    printable: listaBase64[0],
                    type: 'pdf',
                    base64: true,
                    showModal: true
                });

            }).fail(function() {
                alert("No se pudieron cargar las imágenes de la etiqueta.");
            });

        }).catch(function(error) {
            console.error(error);
        });
        };

        vm.partidas = {};

        vm.cargarTodasPartidas = function(pedidoId) {
            vm.loading = true;
            $http.get('/backend/carrier/getpartidas', {
                params: { id: pedidoId }
            }).then(function(response) {
                vm.modalPedido = $uibModal.open({
                    animation: true,
                    templateUrl: '/backend/app/views/partidas.html',
                    controller: function($scope) {
                        $scope.items = response.data.items
                        $scope.pedido = response.data.pedido
                        $scope.koForm = function() {
                            vm.modalPedido.close();
                        }

                        $scope.okForm = function() {
                            vm.modalPedido.close();
                        }
                    }
                });
            }).finally(function() {
                vm.loading = false;
            });
        };


        // TODO: Mostrar erores en los error con un modal
        vm.showModal = function(type, id) {
            CuentaService.getCuentaCarrier(type, id).then(function(data) {
                vm.modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: '/backend/app/views/carrier.html',
                    controller: function($scope) {
                        $scope.type = type;
                        $scope.carriers = [];
                        $scope.info = data.data;
                        $scope.updateSelectedCarrier = function(id) {
                            // Buscamos en el array de carriers el que coincida con el ID seleccionado
                            $scope.selectedCarrier = $scope.carriers.find(function(c) {
                                return c.id == id;
                            });

                            // Limpiamos el servicio seleccionado al cambiar de transportista
                            $scope.selectedService = null;
                        };
                        $scope.koForm = function() {
                            vm.modalInstance.close();
                        }
                        $scope.getCarriers = function() {
                            CarrierService.getCarriers().then(function(response) {
                                $scope.carriers = response.data;
                            }).catch(function(error) {
                                console.error(error);
                            });;
                        };
                        $scope.submitShipping = function() {
                            var numTrackings = parseInt($scope.info.infoEnvio.numero_trackings) || 1;
                            if (!vm.generalService.trackings[id]) {
                                vm.generalService.trackings[id] = [];
                            }
                            
                            var promises = [];
                            for (var i = 0; i < numTrackings; i++) {
                                promises.push(
                                    CarrierService.submitShipment($scope.info, $scope.selectedCarrier, id).then(function(response) {
                                        if (response.data && response.data.tracking) {
                                            vm.generalService.trackings[id].push({ tracking: response.data.tracking, carrier: response.data.carrier });
                                        }
                                    }).catch(function(error) {
                                        console.error(error);
                                    })
                                );
                            }
                            
                            Promise.all(promises).then(function() {
                                // Aplicamos los cambios al scope de Angular en caso de que Promise.all se resuelva fuera del digest cycle
                                if (!$scope.$$phase) {
                                    $scope.$applyAsync();
                                }
                                vm.modalInstance.close();
                            });
                        };
                        $scope.init = function() {
                            $scope.getCarriers();
                            $scope.info.shipment.direccion = $scope.info.infoEnvio.direccion_envio;
                            $scope.info.shipment.cp = $scope.info.infoEnvio.cp_envio;
                            $scope.info.shipment.municipio = $scope.info.infoEnvio.municipio_envio;
                            $scope.info.shipment.provinicia = $scope.info.infoEnvio.provincia_envio;
                        };
                        $scope.init();

                    },
                    size: 'lg',
                });
            })

        }
    }

})();
